export const init = () => { // eslint-disable-line import/prefer-default-export
  wrapClubList();
};

const wrapClubList = () => {
  const clubs = [...document.getElementsByClassName('v65-club')];
  if (!clubs.length) {
    return false;
  }

  const clubList = document.createElement('div');
  clubList.className = 'club-list';
  clubs[0].parentElement.insertBefore(clubList, clubs[0]);
  clubs.forEach(club => clubList.appendChild(club));
  return clubList;
};



// WEBPACK FOOTER //
// ./src/assets/js/clubs.js